/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Public_Usage_NoteInputs */

const en_pricing_public_usage_note = /** @type {(inputs: Pricing_Public_Usage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits are used when you generate a video. The cost depends on the clip length and resolution, and is always shown before you confirm.`)
};

const es_pricing_public_usage_note = /** @type {(inputs: Pricing_Public_Usage_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los créditos se usan al generar un video. El costo depende de la duración y la resolución del clip, y siempre se muestra antes de confirmar.`)
};

/**
* | output |
* | --- |
* | "Credits are used when you generate a video. The cost depends on the clip length and resolution, and is always shown before you confirm." |
*
* @param {Pricing_Public_Usage_NoteInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_usage_note = /** @type {((inputs?: Pricing_Public_Usage_NoteInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_Usage_NoteInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_usage_note(inputs)
	return es_pricing_public_usage_note(inputs)
});